var Marionette = require('marionette'),
	Backbone = require('backbone'),
    BaseSidePanel = require('../panelCommon/paneViewBase');

module.exports = BaseSidePanel.extend({
	side: 'right',
	panelTemplate: require('./rightPanel.hbs'),
	ui: {
		notes: 		'.FV-notes-panel',
		fullText: 	'.FV-full-text-panel'
	}
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/panelRight/rightPanelView.js
 ** module id = 749
 ** module chunks = 0
 **/